export function getVerificationText(
    medium?: string,
    destination?: string,
): string {
    if (!medium || !destination) {
        return 'We sent a code to you'
    }

    const phone = destination.substring(destination.length - 4)

    return `We sent a ${medium} to your phone number ending ${phone}`
}
